import * as React from "react"
export const Svg_065 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path fill="url(#b)" d="M38.143 39.985h9.487v3.457h-9.487v-3.457Z" />
      <path fill="url(#c)" d="M18.63 15.557h29v6.915h-29v-6.915Z" />
      <path
        fill="url(#d)"
        d="M7.26 5.186v46.727c0 .67-.124 1.31-.349 1.901h46.73a5.364 5.364 0 0 0 5.36-5.358V5.186H7.26Zm7.912 6.914h35.915V25.93H15.172V12.1ZM31.23 46.9H15.172v-3.458h16.057V46.9Zm0-6.915H15.172v-3.457h16.057v3.457Zm19.858 6.914H34.686V36.528h16.401v10.371Zm0-13.829H15.172v-3.457h35.915v3.457Z"
      />
      <path
        fill="url(#e)"
        d="M0 51.913c0 1.048.853 1.901 1.901 1.901a1.903 1.903 0 0 0 1.902-1.901v-22.3H0v22.3Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={40.337}
        x2={41.124}
        y1={40.503}
        y2={43.999}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={25.336}
        x2={26.395}
        y1={16.595}
        y2={23.784}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={18.957}
        x2={41.314}
        y1={12.48}
        y2={51.239}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={0.879}
        x2={7.019}
        y1={33.243}
        y2={34.805}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)